module.exports = __webpack_public_path__ + "img/home.f1cd37ac.jpg";